module.exports = __webpack_public_path__ + "static/media/8-1.478ba5ac.mp3";